import { ExportCSVButton } from 'applicationTable/ExportCSVButton/ExportCSVButton';
import { ExternalFilters } from 'applicationTable/ExternalFilters/ExternalFilters';
import { DashboardSettings } from 'components/DashboardSettings/DashboardSettings';
import { useIntroducerContext } from 'contexts/IntroducerContext/IntroducerContext';
import { useApplicationTable } from '../ApplicationTable.context';
import styles from './ApplicationTableHeader.module.css';
import { SearchBar } from './searchBar/SearchBar';

export const ApplicationTableHeader = () => {
  const {
    state: { error },
  } = useApplicationTable();
  const { isContextError } = useIntroducerContext();

  if (error || isContextError) {
    return null;
  }

  return (
    <header className={styles.header}>
      <div className={styles.leftSection}>
        <ExternalFilters />
        <SearchBar />
      </div>

      <div className={styles.rightSection}>
        <ExportCSVButton />
        <DashboardSettings />
      </div>
    </header>
  );
};
